export const notifyOverLimits = () => (Notify.create({
  title: bfTranslate("Asset limit reached."),
  body: bfTranslate("Contact support to upgrade your asset limit."),
  type: "error"
}));
